<template>
  <div class="matterContainer">
    <div style="min-height: 450px;">
      <div class="breadcrumb">
        <span class="breadcrumbText">当前位置：首页 > </span>
        <span v-if="typeof labelName ==='object'">
          <a class="hoverClass" @click="backFirstHandle">{{ labelName.firstLabelName }}</a>
          <span> > </span>
          <a class="hoverClass" @click="backHandle">{{ labelName.labelName }}</a>
        </span>
        <a class="hoverClass" @click="backHandle" v-else>{{ labelName }}</a>
      </div>
      <template v-for="matter in matterList">
        <div :key="matter.iid" class="matterNameClass" @click="toOneThingGuide(matter.iid, matter.itemName, matter)">
          <a-icon :component="point" style="margin-right: 16px;" :style="{ fontSize: '3px'}" />
          <a class="hoverClass">{{ matter.itemName }}</a>
        </div>
      </template>
    </div>
    <!-- <div v-show="totalCount > 20" style="text-align:center;margin: 30px;folot: bottom;"> -->
    <div v-show="totalCount > 20" style="text-align:center;margin: 30px;">
      <a-pagination
        size="small"
        :total="totalCount"
        v-model="params.pageNo"
        @change="pageChange"
        show-quick-jumper
        :show-total="total => `共有 ${total} 条`"
      />
    </div>
  </div>
</template>

<script>
import { jiopWebAPI } from '@/api/jiopweb/jiopweb.js'
import point from '../point.svg?inline'
export default {
  name: 'MatterList',
  data () {
    return {
      point,
      labelName: '',
      params: {
        pageNo: 1,
        pageSize: 20,
        districtId: sessionStorage.getItem('districtId'),
        labelId: ''
      },
      totalCount: 0,
      matterList: []
    }
  },
  methods: {
    init (labelId, labelName) {
      if (labelId) {
        this.labelName = labelName
        this.params.labelId = labelId
      }
      jiopWebAPI.matterList(this.params).then(res => {
        this.totalCount = res.data.list.length
        this.matterList = res.data.list.filter((v, index) => {
          return (this.params.pageNo - 1) * 10 <= index && index < 10 * this.params.pageNo
        })
      })
    },
    backHandle () {
      this.params.pageNo = 1
      this.$emit('backLabel', this.params.labelId)
    },
    backFirstHandle () {
      this.params.pageNo = 1
      this.$emit('backFirstHandle', this.params.labelId)
    },
    pageChange (pageNo) {
      this.params.pageNo = pageNo
      this.init()
    },
    toOneThingGuide (value, name, itt) {
      sessionStorage.setItem('matter_name', itt.oneThingName)
      const url = this.$router.resolve({ path: '/guideSimple', query: { itemId: value, bannerType: this.$route.query.bannerType } })
      window.open(url.href, '_blank')
    }
  }
}
</script>

<style scoped lang="less">
.hoverClass {
  color: rgba(89, 89, 89, 1);
}
.hoverClass:hover {
  color: #1677FF;
}
.matterContainer {
  width: 1300px;
  margin: auto;
  padding-left: 50px;
  padding-top: 20px;
}
.breadcrumb {
  padding-bottom: 14px;
  .breadcrumbText {

    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 400;
  }
}
.point {
  display: inline-block;
  height: 1px;
  width: 1px;
  border: #333333 2px solid;
  margin-right: 16px;
}
.matterNameClass {

  font-size: 16px;
  color: #333333;
  line-height: 28px;
  font-weight: 400;
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #D7D8D9;
}
</style>
